import '../css/main.scss';
//import './vendor/jquery.nice-select';
import './includes/nav';
import './includes/search';
// import './includes/filters';
//import './vendor/plugins';
//alert('test');

// jQuery(document).on('scroll', function () {
// 	console.log('Riverine Go');
// 	// var vphm = jQuery(window).height();
// 	var vphm = 400;

// 	if (jQuery(document).scrollTop() > vphm) {
// 		jQuery('.nav-header').addClass('color-change');
// 	} else {
// 		jQuery('.nav-header').removeClass('color-change');
// 	}
// });

jQuery(document).ready(function () {
	var descriptionimage = jQuery('.description-image-lightbox').html();
	jQuery('.description-image-lightbox-summary').html(descriptionimage);
});
